export default {
	props: {
		categoryId: {type: Number, required: false}
	},
	computed: {
		noItems: (t) => !t.groups.some(x => x.items.length),
		groups() {
			const groups = this.$store.getters["products/groups"];
			return groups.filter(x => this.categoryId ? x.id === this.categoryId : true);
		}
	},
	render() {
		return this.$scopedSlots.default({
			noItems: this.noItems,
			groups: this.groups
		});
	}
};
